<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div>
      <div class="curriculum_top_box">
        <div class="currency_box from_flex">
          <div class="form_content">
            <div class="curriculum_title font24">{{info.username}}
              <!-- | 钧策资深营采实战专家 -->
            </div>
            <div>
              <ul class="curriculum_ul">
                <li class="curriculum_li">
                  {{info.personalProfile}}</li>
              </ul>
            </div>
            <!-- <pre class="pre font16">{{info.personalProfile}}</pre> -->
            <div class="flexStart">
              <div class="label font20">擅长领域</div>
              <div style="flex:1;color: #999;">{{info.expertiseAreas}}</div>
            </div>
            <div>
              <!-- <div class="label font14">常住地 武汉市</div>
              <div class="label font14">课程数 8堂</div> -->
              <div class="label font14">从业年限 {{info.workYears}}年</div>
            </div>
          </div>
          <!-- 课程 -->
          <div class="kc">
            <el-image style="width:100%;height:100%"
                      :src="info.headPortrait"></el-image>
          </div>
        </div>
      </div>
      <!-- 课程详情 -->
      <div class="curriculum_details">
        <div class="currency_box">
          <div class="flexStart">
            <div v-if="lecturerType == 1"
                 class="title">
              <!-- {{info.username}} -->
              <img :src="$imgUrl + 'RetailTraining/icon_img.png'"
                   alt=""> 线上课
            </div>
            <div v-if="lecturerType == 2"
                 class="title">
              <img :src="$imgUrl + 'OnlineBusinessSchool/icon_top.png'"
                   alt="">
              <!-- {{info.username}}  icon_top.png -->
              线下活动
            </div>
            <div v-if="lecturerType == 3 || lecturerType == 4"
                 class="title">
              <!-- {{info.username}} -->
              <img :src="$imgUrl + 'OnlineBusinessSchool/icon_top.png'"
                   alt="">
              实战案例
            </div>
            <!-- <span :class="tabIndex == index?'activeTab mainColor font16':'tab font14'"
                  v-for="(item,index) in tabList"
                  :key="index">{{item}}</span> -->
          </div>
        </div>
        <div class="currency_box">
          <curriculumItem v-if="lecturerType == 1"
                          :data="courseData"
                          bg="#f5f5f5"
                          status="more"></curriculumItem>
          <activity v-if="lecturerType == 2"
                    :list="dataList"></activity>
          <Item :data="articleData"
                v-if="lecturerType == 3 || lecturerType == 4"></Item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import activity from '@/components/activity/activity.vue'  //活动
import curTitle from '@/components/home/cur_title.vue'
import curriculumItem from '@/components/OnlineBusinessSchool/curriculum_item.vue' //课程
import Item from '../../Cooperationcases/components/item.vue'
import { lecturerInfo, lecturercourseList, activityList, articleList } from '@/api/api.js'
export default {
  components: { curTitle, curriculumItem, activity, Item },
  data () {
    return {
      tabIndex: 0,
      tabList: ['最新', '最热', '最冷'],
      dataList: [],
      courseData: {},
      articleData: {},
      lecturerType: 1,
      info: {},
      lectureId: '',
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      breadcrumbList: [
        { name: '课程详情' }
      ],
      list: [
        { title: '时长：6小时54分' }, { title: '课后绑定考试' }, { title: '配套思维导图' }
      ],
      type: 'kc',
      tabPosition: 'top',
      form: { name: '' }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.$route.query.lectureId) {
        this.lectureId = this.$route.query.lectureId;
        this.lecturerType = this.$route.query.lecturerType;
        let data = {
          lectureId: this.lectureId,
          lecturerType: this.lecturerType,
          pageNumber: 1,
          pageSize: 6
        }
        this.getInfo()
        // console.log(this.lecturerType)
        switch (Number(this.lecturerType)) {
          case 1:
            data.pageNumber = 1;
            data.pageSize = 8;
            this.getlecturercourseList(data);
            break;
          case 2:
            this.getactivityList(data);
            break;
          case 3:
            this.getarticleList(data);
            break;
          case 4:
            this.getarticleList(data);
            break;
        }
      }
    },
    async getInfo () { //讲师信息
      const res = await lecturerInfo(this.lectureId)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      // console.log(res)
      this.info = res.data;
    },
    async getlecturercourseList (data) {  //讲师线上课程
      const res = await lecturercourseList(data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      // console.log(res)
      this.courseData = res.data;
    },
    async getactivityList (data) {  //线下活动
      const res = await activityList(data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      // console.log(res)
      this.dataList = this.split_array(res.data.records, 3);
      // console.log(this.dataList)
    },
    async getarticleList (data) {
      const res = await articleList(data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      let arr = { bg: '#f5f5f5', itembg: '#fff', status: 'more' }
      this.articleData = { ...res.data, ...arr };
    },
    split_array (array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      // console.log(newArray)
      return newArray;
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  background-color: #f5f5f5;
  min-height: 100vh;
  // padding-top: 30px;

  .curriculum_top_box {
    // margin: 20px 0 0 0;
    background-color: #343333;
    // height: 500px;
    padding: 50px 0 40px 0;
    box-sizing: border-box;
    .from_flex {
      display: flex;
      align-items: flex-start;
      height: 100%;
      .kc {
        width: 328px;
        height: 368px;
        border: 8px solid #d7d7d7;
        box-sizing: border-box;
      }
      .form_content {
        flex: 1;
        margin-left: 24px;
        div {
          margin-bottom: 15px;
        }
        .pre {
          color: #999999;
        }
        .curriculum_title {
          color: #ffffff;
        }
        .curriculum_fu_title {
          color: #666;
        }
        .curriculum_label {
          display: inline-block;
          padding: 9px 12px;
          box-sizing: border-box;
          background-color: #ffeced;
          border-radius: 16px;
        }
        .label {
          display: inline-block;
          padding: 14px;
          box-sizing: border-box;
          border-radius: 6px;
          border: 1px solid #999;
          color: #999;
          margin-right: 40px;
        }
        .curriculum_ul {
          color: #999999;
          .curriculum_li {
            margin-right: 20px;
            margin-bottom: 4px;
          }
        }
      }
    }
  }
  .curriculum_details {
    padding-top: 20px;
    background-color: #f5f5f5;
    .title {
      margin-right: 20px;
      font-weight: bold;
      font-size: 40px;
      display: flex;
      align-items: center;
      img {
        margin-right: 20px;
      }
    }
    .activeTab {
      cursor: pointer;
      display: inline-block;
      margin-right: 15px;
      font-weight: bold;
    }
    .tab {
      display: inline-block;
      margin-right: 15px;
      color: #333333;
    }
    .tab:hover {
      cursor: pointer;
    }
  }
}
</style>
